import { styled } from 'styled-components';

import { WRAPPER } from '@/shared/styles/themes';

const RootContainer = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  background: #131315;
  width: 100%;
  @media (min-width: 768px) {
    padding: 30px 0;
    margin-bottom: 60px;
  }
`;

const BannerContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 50px;
  justify-content: center;
  align-items: center;


  @media (max-width: 768px) {
    aspect-ratio: 836 / 576;
    width: 100%;
  }
  @media (min-width: 767px) {
    height: 216px;
  }

`;
const BannerVideo = styled.video`
  width: 100%;
  height: auto;
  object-fit: contain;
`;
// const BannerImage = styled.img`
//   width: 100%;
//   height: auto;
//   object-fit: contain;
// `;

// const BannerNotAuth = styled.img`
//   width: 100%;
//   overflow: hidden;
//   border-radius: 12px;

//   @media (min-width: 768px) {
//     height: 220px;
//   }
// `;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: min(1132px, 100%);
  padding: 24px 0;
  gap: 24px;
`;
const InfoContainer = styled.div`
  color: #fff;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  width: 100%;
  padding-left: 18px;
  padding-right: 18px;

  @media (min-width: 768px) {
    flex-grow: 1;
    padding: 12px;
    width: 100%;
    min-width: 45%;
    max-width: 72%;
    text-align: center;
  }
`;
const HintAndInfoDesktop = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  padding: 30px 0;
  justify-content: center;
  @media (max-width: 768px) {
    padding-left: 18px;
    padding-right: 18px;
  }
`;

const Wrapper = styled.div`
  ${WRAPPER};
  display: flex;
  margin: 0;
  flex-direction: column;
  align-items: center;
  align-content: center;
  max-width: min(100%, 1132px);
  @media (max-width: 768px) {
    margin-top: 0;
    max-width: 100%;
    width: 100%;
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  width: min(100%, 1132px);
  flex-direction: column;
  align-items: center;
  align-content: center;
`;

const AuthButtonsBleed = styled.div`
  width: 100%;

  @media (max-width: 768px) {
    align-self: stretch;
    width: auto;
  }
`;

export {
  RootContainer,
  BannerContainer,
  BannerVideo,
  Content,
  InfoContainer,
  HintAndInfoDesktop,
  Wrapper,
  ContentWrapper,
  AuthButtonsBleed,
};
